import { render, staticRenderFns } from "./UpdateStudent.vue?vue&type=template&id=1aaa2648&scoped=true"
import script from "./UpdateStudent.vue?vue&type=script&lang=js"
export * from "./UpdateStudent.vue?vue&type=script&lang=js"
import style0 from "./UpdateStudent.vue?vue&type=style&index=0&id=1aaa2648&lang=css"
import style1 from "./UpdateStudent.vue?vue&type=style&index=1&id=1aaa2648&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa2648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aaa2648')) {
      api.createRecord('1aaa2648', component.options)
    } else {
      api.reload('1aaa2648', component.options)
    }
    module.hot.accept("./UpdateStudent.vue?vue&type=template&id=1aaa2648&scoped=true", function () {
      api.rerender('1aaa2648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/UpdateStudent.vue"
export default component.exports